// Which evaluation a Powers view displays. Both instruments come from one PowersData / PersonProfile
// read: the self-assessment (`selfAssessmentResults` / `powersEvaluationResults`, the person's own rating)
// and the smart analysis (`smartAnalysisResults`, the AI reading of their documents). "combined" is the
// third lens, computed client-side - see combineLevels. Shared by the Power Map and the profile's Powers
// box so both mean the same thing by the same word.
export type ScoreSource = "self" | "smart" | "combined";

export type LevelMap = ReadonlyMap<string, number | null | undefined>;

// Combined ("gewichtet") = mean of the per-source scores that exist for a key (self + smart), rounded,
// mirroring genesis' fetchLatestAveragedScores (latest per type, averaged across types). A key present in
// either map but scored in neither stays in the result as null, so "assessed nowhere" remains
// distinguishable from "absent". Computed from the two values callers already load; no extra backend call.
export function combineLevels(self: LevelMap, smart: LevelMap): Map<string, number | null> {
  const combined = new Map<string, number | null>();
  for (const key of new Set([...self.keys(), ...smart.keys()])) {
    const values = [self.get(key), smart.get(key)].filter((v): v is number => typeof v === "number");
    combined.set(
      key,
      values.length ? Math.round(values.reduce((a, b) => a + b, 0) / values.length) : null,
    );
  }
  return combined;
}
